module.exports = __webpack_public_path__ + "static/logo-d546e0a0434e3aba18350c9be35e9bab.svg";